import {
  LocalAuthState,
  LocalAuthStateLegacy,
  UserRoleLegacy,
} from './state.type';
import { getItem, setItem, removeItem } from './utils/local-storage';

const authStateStorageKey = 'AuthStateKC';

function getAuthState(): LocalAuthState | null {
  const authStateFromStorage = getItem(authStateStorageKey);

  if (!authStateFromStorage) {
    return null;
  }

  const state = JSON.parse(authStateFromStorage);

  return state as LocalAuthState;
}

function getAuthStateLegacy(): LocalAuthStateLegacy | null {
  const state = getAuthState();

  if (!state) {
    return null;
  }

  let role = UserRoleLegacy.CARRIER;
  for (const legacyRole in UserRoleLegacy) {
    if (state.user.roles?.includes(legacyRole)) {
      role = legacyRole as UserRoleLegacy;
      break;
    }
  }

  return {
    token: state.token,
    username: state.user.email,
    companyId: state.user.tenantId as unknown as number,
    userId: state.user.userId as unknown as number,
    role,
    impersonator: state.impersonator?.id,
  };
}

function setAuthState(state: LocalAuthState): void {
  const storableAuthState = JSON.stringify(state);

  setItem(authStateStorageKey, storableAuthState);
}

function clearAuthState(): void {
  removeItem(authStateStorageKey);
}

export { getAuthState, setAuthState, clearAuthState, getAuthStateLegacy };
